import React, { useEffect, useState } from 'react';
import { SexInputs } from './AddGeneModal.tsx';
import { MorphSelect } from '../../utilities/MorphSelect.tsx';
import { ReptoolModal } from '../../utilities/ReptoolModal.tsx';
import { BasicFetch } from '../../../utils/BasicFetch.ts';
import { Morph } from '../../../types/Morph.ts';
import { driver } from 'driver.js';
export const AddMorphModal = ({
    status,
    morphs,
    closeModal,
    updateGroups,
    isSpecies,
    lockStatus = false,
    preselectedReptile
}: {
    status: string,
    morphs: Morph[],
    closeModal: () => void,
    updateGroups: () => void,
    isSpecies: boolean,
    lockStatus?: boolean,
    preselectedReptile?: string
}) => {
    const tabs = [
        { label: "Available", status: "available" },
        { label: "Not For Sale", status: "nfs" },
        { label: "Sold", status: "sold" }
    ];

    const driverObj = driver({
        steps: [
            { element: '#morph-dialog #status-choice-container', popover: { title: 'Status', description: 'Select the status of the reptile you are adding (available, not for sale, or sold).' } },
            { element: '#morph-dialog #quantity-add-genes', popover: { title: 'Quantities', description: 'Specify how many reptiles you are adding.' } },
            { element: '#morph-dialog .genes-dialog-container', popover: { title: 'Morph', description: 'Select the morph of the reptile you are adding. If you need to specify het genes or can\'t find the morph you\'re looking for please try the \'Add by Genes\' option from the previous menu.' } },
            { element: '#morph-dialog #add-to-genes-morph', popover: { title: 'Add To Collection', description: 'Add the reptile to your collection.' } },
        ]
    });

    const [selectedMorph, setSelectedMorph] = useState<Morph>({ name: '' });
    const [selectedStatus, setSelectedStatus] = useState(status);
    const [genderQuantities, setGenderQuantities] = useState({ males: 0, females: 0, unsexed: 0 });
    const [valid, setValid] = useState(false);
    const [currentText, setCurrentText] = useState("");
    const [selectedReptile, setSelectedReptile] = useState<string>(preselectedReptile ? preselectedReptile : localStorage.getItem('selectedReptile') || '');
    
    const createGroup = () => {
        if (!valid) {
            alert("Inputs not valid. Please specify how many reptiles you are adding.");
            return;
        }
        if (!selectedMorph.name) {
            alert("Inputs not valid. Please choose a valid morph.");
            return;
        }
        const data = {
            females: genderQuantities.females,
            males: genderQuantities.males,
            morphName: selectedMorph.name,
            reptile: selectedReptile,
            status: selectedStatus,
            unknown: genderQuantities.unsexed,
            morphNameId: selectedMorph.morph_name_id
        }
        BasicFetch({
            url: `${(window as any).serverLocation}/reptile/reptile_group/create`,
            data: data,
            method: 'POST',
            onSuccess: (data) => {
                window.alert(`Successfully added ${selectedMorph.name}`)
                closeModal();
                updateGroups();
            },
            onFail: (error) => {
                console.log(error)
                window.alert(error)
            },
        })
    }
    useEffect(() => {
        let quantity = 0;
        Object.keys(genderQuantities).forEach(gender => {
            quantity += genderQuantities[gender];
        })
        setValid(quantity > 0)
    }, [currentText, genderQuantities])
    return (
        <ReptoolModal id={"morph-dialog"} title={"Add To Collection"} showTutorial={() => driverObj.drive()} closeModal={closeModal} body={(
            <React.Fragment>
                {!lockStatus && <div id="status-choice-container">
                    <select className='w-100' defaultValue={selectedStatus} onChange={(event) => setSelectedStatus(event.target.value)} >
                        {tabs.map((tab) => (
                            <option key={tab.status} value={tab.status}>{tab.label}</option>
                        ))}
                    </select>
                </div>}
                <div className="w-100 no-pad my-3 label-title">
                    <h3>How Many Do You Want To Add?</h3>
                </div>
                <SexInputs setValues={(values) => setGenderQuantities(values)} />
                <div className="genes-dialog-container">
                    <MorphSelect
                        morphs={morphs}
                        getCurrentText={(text) => setCurrentText(text)}
                        morphTyped={(morph) => setSelectedMorph(morph)}
                        morph={selectedMorph}
                        id={'add-morph-select'}
                        isSpecies={isSpecies}
                    />
                </div>
                <hr />
                <div className="text-center mt-5">
                    <div id="add-to-genes-morph" className={`add-to-collection button ${valid ? '' : 'disabled'}`}
                        onClick={createGroup}>
                        Add to Collection
                    </div>
                </div>
            </React.Fragment>
        )} />
    )
}